import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';

class ChartsSidebar extends Component {

    static propTypes = {
        path: PropTypes.string
    };

    static defaultProps = {
        path: '/charts'
    };

    state = {
        visible: true
    };


    componentWillMount = () => {
        this.sideMenuActivate();
    };

    componentDidMount = () => {
        window.addEventListener("resize", this.sideMenuActivate, false);
    };

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.sideMenuActivate, false);
    };

    sideMenuActivate = () => {
        if (window.matchMedia("(max-width: 640px)").matches) {
            this.setState({visible: false});
        } else {
            this.setState({visible: true});
        }
    };

    render() {

        return (
            <aside className="charts__sidebar">
                <button type="button" aria-label="Use the dropdown menu to navigate to a different page" aria-haspopup="true" aria-expanded="false" onClick={() => this.setState({visible: !this.state.visible})}>Charts <i className="fas fa-caret-down" aria-hidden="true" /></button>
                <ul className={this.state.visible ? 'sidebar__menu sidebar__menu--visible' : 'sidebar__menu'}>
                    <li className="sidebar__group">
                        <h3>Market Analysis</h3>
                        <ul>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/market-insights/0`} onClick={() => this.setState({visible: false})}>HG Trading Activity</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/market-insights/1`} onClick={() => this.setState({visible: false})}>HY Trading Activity</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/market-insights/2`} onClick={() => this.setState({visible: false})}>Average Trade Size</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/market-insights/3`} onClick={() => this.setState({visible: false})}>HG Turnover</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/market-insights/4`} onClick={() => this.setState({visible: false})}>Traded CUSIPS</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/market-insights/5`} onClick={() => this.setState({visible: false})}>Corporate Debt Outstanding</NavLink></li>
                            <li><NavLink activeClassName="active" to={`${this.props.path}/market-insights/6`} onClick={() => this.setState({visible: false})}>Primary Dealer Net Positions</NavLink></li>
                        </ul>
                    </li>
                    <li className="sidebar__group">
                        <ul>
                            <li><NavLink activeClassName="active" to={`/index/CPP-basi/0`} onClick={() => this.setState({visible: false})}>BASI Indices</NavLink></li>
                        </ul>
                    </li>
                </ul>
            </aside>
        );
    }
}

export default ChartsSidebar;



// WEBPACK FOOTER //
// ./frontend/pages/Charts/ChartsSidebar.jsx